
export const GET_CURRENT_ID = state => state.currentId;




// WEBPACK FOOTER //
// ./src/store/getters.js